// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","left":"Footer_left__9v7z1","right":"Footer_right__x49Kn","item":"Footer_item__Zb229"};